const trataAtleta = (codigo) => {
  let novoCodigo = codigo;

  const segundaPosicao = novoCodigo.charAt(1);
  const terceiraPosicao = novoCodigo.charAt(2);

  if (
    segundaPosicao &&
    terceiraPosicao &&
    !isNaN(segundaPosicao) &&
    !isNaN(terceiraPosicao)
  ) {
    // Se ambas forem números, define 'atleta' com esses dois números
    novoCodigo = segundaPosicao + terceiraPosicao;
  } else if (segundaPosicao && !isNaN(segundaPosicao)) {
    // Se apenas a segunda posição for número, define 'atleta' com zero à esquerda
    novoCodigo = "0" + segundaPosicao;
  } else {
    // Caso contrário, define 'atleta' como null
    novoCodigo = null;
  }

  return novoCodigo;
};

const trataInicio = (codigo) => {
  // Lógica para definir 'codigos' com base na primeira letra
  let codigoAtualizado = codigo;
  if (
    codigoAtualizado.charAt(0).toLowerCase() !== "a" &&
    codigoAtualizado.charAt(0).toLowerCase() !== "*"
  ) {
    codigoAtualizado = "*" + codigo;
  }
  // return codigoAtualizado.toUpperCase();
  return codigoAtualizado;
};

const converteCodigo = (codigo) => {
  // Identifica o time da ação
  let codigoAtualizado = trataInicio(codigo);

  // Verifica se o terceiro caractere existe e se não é um número
  if (
    (codigoAtualizado.charAt(2) && isNaN(codigoAtualizado.charAt(2))) ||
    codigoAtualizado.length === 2
  ) {
    // Insere um zero entre o primeiro e o segundo caractere
    codigoAtualizado =
      codigoAtualizado.slice(0, 1) + "0" + codigoAtualizado.slice(1);
  }
  return codigoAtualizado;
};

const desafioQualidade = (code, skill) => {
  const basic = {
    "#": "-",
    "=": "#",
    "/": "+",
    "+": "/",
    "!": "-",
    "-": "!",
  };
  const block = {
    "#": "<",
    "=": "#",
    "/": "+",
    "+": "/",
    "!": "-",
    "-": "!",
  };
  if (skill === "B") {
    return block[code] || code;
  } else {
    return basic[code] || code;
  }
};
const parFundamento = (code) => {
  const mapeamento = {
    S: "R",
    A: "B",
    B: "A",
  };

  return mapeamento[code] || code;
};

const quality = ["#", "=", "/", "+", "!", "-"];
const skills = ["S", "R", "E", "A", "D", "B", "F"];
const power = ["H", "M", "Q", "T", "U", "N", "O"];

const separaBlocos = (blocos) => {
  const blocosComPontos = [];

  blocos.forEach((bloco) => {
    const partes = bloco.split(".");

    if (partes.length === 2) {
      let [parte1, parte2] = partes; //quebra o bloco em duas partes
      let power1, power2;

      parte1 = converteCodigo(parte1); //numero para duas posicoes

      parte1 = incluiFundamento(parte1, 2);

      const inicioParte1 = parte1.charAt(0);

      const novoBloco2 = `${inicioParte1 === "*" ? "a" : "*"}${parte2}`;

      parte2 = converteCodigo(novoBloco2);
      const skillBloco2 = parFundamento(parte1.charAt(3));

      parte2 = parte2.slice(0, 3) + skillBloco2 + parte2.slice(3); // incluiu o B

      const tipo = parte2.length === 6 ? 2 : 1;

      parte2 = incluiFundamento(parte2, tipo);
      const qualityBloco1 = desafioQualidade(
        parte2.charAt(5),
        parte2.charAt(3)
      );

      parte1 = parte1.slice(0, 5) + qualityBloco1 + parte1.slice(5);

      const qualityAtfour = quality.includes(parte2.charAt(5));

      if (!qualityAtfour) {
        parte2 = parte2.slice(0, 4) + parte1.charAt(5) + parte2.slice(4);
      }

      parte2 = parte2.slice(0, 4) + parte1.charAt(4) + parte2.slice(5); //incluiu H antes do b

      blocosComPontos.push(parte1, parte2);
    } else {
      const novoBloco = incluiFundamento(bloco, 1);
      blocosComPontos.push(novoBloco);
    }
  });

  return blocosComPontos;
};

const incluiFundamento = (bloco, tipo) => {
  let codigoConvertido = converteCodigo(bloco);
  // console.log(codigoConvertido);

  const skill = skills.includes(codigoConvertido.charAt(3));
  // console.log(codigoConvertido.charAt(3));

  // console.log(skill);

  if (!skill) {
    codigoConvertido =
      codigoConvertido.slice(0, 3) + "A" + codigoConvertido.slice(3);
  }
  // console.log(codigoConvertido);

  const power1 = power.includes(codigoConvertido.charAt(4)) ? "" : "H";
  const novoBloco =
    codigoConvertido.slice(0, 4) +
    power1 +
    // qualityBloco1 +
    codigoConvertido.slice(4);

  if (!quality.includes(novoBloco.charAt(5)) && tipo === 1) {
    codigoConvertido = novoBloco.slice(0, 5) + "!" + novoBloco.slice(5);
  } else {
    codigoConvertido = novoBloco;
  }
  return codigoConvertido;
};

const trocaLibero = (numbers, team, tiimeSacador, teamType) => {
  // Clonar para evitar mutação direta
  const updatedNumbers = [...numbers];

  // Posições a verificar: sempre verifica 4 e 5
  const positionsAlwaysCheck = [4, 5];

  positionsAlwaysCheck.forEach((pos) => {
    const number = numbers[pos];
    const playerData = team?.find((p) => String(p.number) === String(number));
    const playerFunction = playerData?.function || null;

    if (playerFunction === "c") {
      // Troca com a posição 6 (index 6)
      const temp = updatedNumbers[pos];
      updatedNumbers[pos] = updatedNumbers[6];
      updatedNumbers[6] = temp;
    }
  });

  // Agora verifica posição 0 **só se** for o time sacador correto
  const isCorrectTeam =
    (teamType === "home" && tiimeSacador === "a") ||
    (teamType === "away" && tiimeSacador === "*");

  if (isCorrectTeam) {
    const number = numbers[0];
    const playerData = team?.find((p) => String(p.number) === String(number));
    const playerFunction = playerData?.function || null;

    if (playerFunction === "c") {
      // Troca com a posição 6 (index 6)
      const temp = updatedNumbers[0];
      updatedNumbers[0] = updatedNumbers[6];
      updatedNumbers[6] = temp;
    }
  }

  return updatedNumbers;
};

const getAtletaPorNumero = (numero, equipe) => {
  if (!numero || !equipe) return null;

  // const atleta = equipe.find((jogador) => jogador.number === numero);
  const atleta = equipe.find(
    (jogador) => String(jogador.number) === String(numero)
  );

  if (!atleta) return null;

  return {
    name: atleta.name,
    nomeCompleto: `${atleta.name} ${atleta.surname}`,
    funcao: atleta.function, // "líbero", "levantador", etc.
  };
};

const corPorFuncao = (funcao) => {
  switch (funcao?.toLowerCase()) {
    case "l":
    case "libero":
      return "#FFD700"; // amarelo
    case "levantador":
      return "#1E90FF"; // azul
    case "oposto":
      return "#FF4500"; // laranja
    case "central":
      return "#32CD32"; // verde
    case "ponteiro":
      return "#800080"; // roxo
    default:
      return "gray";
  }
};

export {
  trataAtleta,
  trataInicio,
  converteCodigo,
  separaBlocos,
  trocaLibero,
  getAtletaPorNumero,
  corPorFuncao,
};
